<template>
  <div class="site-aside-container">
    <template v-if="data">
      <div class="avatar">
        <Avatar :url="data.avatar" :size="150" />
    </div>
    <h1 class="title">{{ data.siteTitle }}</h1>
    </template>
    <Menu />
    <Contact v-if="data"/>
    <p v-if="data" class="footer">
      {{ data.icp }}
    </p>
  </div>
</template>

<script>
import Avatar from './Avatar.vue';
import Menu from './Menu.vue';
import Contact from './Contact.vue';
import {mapState} from "vuex";
export default {
  components: {
    Avatar,
    Menu,
    Contact,
  },
  computed:mapState("setting",["data"])
}
</script>

<style scoped lang="less">
@import "../style/var.less";
.site-aside-container{
  width: 100%;
  height: 100%;
  background: @dark;
  padding: 20px 0;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}
.avatar{
  display: flex;
  justify-content: center;
}
.footer{
  font-size: 12px;
  text-align: center;
}
.title{
  font-size: 1.2em;
  color: #fff;
  text-align: center;
}
</style>